import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }  from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { OportunitatsComponent } from './oportunitats.component';
import { OportunitatsFiltersComponent } from './oportunitats-filters/oportunitats-filters.component';

import { OportunitatsService } from './oportunitats.service';
import { ListOportunitatsService } from './list.service';

import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  providers: [
    OportunitatsFiltersComponent,
    ListOportunitatsService,
    OportunitatsService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ],
  declarations: [
    OportunitatsComponent,
    OportunitatsFiltersComponent
  ]
})
export class OportunitatsModule { }
